import { render, staticRenderFns } from "./item-locations.vue?vue&type=template&id=428d8c1e&scoped=true"
import script from "./item-locations.vue?vue&type=script&lang=js"
export * from "./item-locations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d8c1e",
  null
  
)

export default component.exports